import { styled } from '@mui/material';

const NoticeList = styled('ul')({
  margin: '0.5rem 2rem'
});

export { NoticeList };
